import { faCirclePlay } from '@fortawesome/pro-regular-svg-icons/faCirclePlay';
import { faBan } from '@fortawesome/pro-regular-svg-icons/faBan';
import { faCircleCheck } from '@fortawesome/pro-regular-svg-icons/faCircleCheck';
import { faCirclePause } from '@fortawesome/pro-regular-svg-icons/faCirclePause';
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons/faCircleXmark';
import { faFlask } from '@fortawesome/pro-regular-svg-icons/faFlask';
import { faForwardStep } from '@fortawesome/pro-regular-svg-icons/faForwardStep';
import { faGaugeHigh } from '@fortawesome/pro-regular-svg-icons/faGaugeHigh';
import { faHourglassHalf } from '@fortawesome/pro-regular-svg-icons/faHourglassHalf';
import { faMerge } from '@fortawesome/pro-regular-svg-icons/faMerge';
import { faRefresh } from '@fortawesome/pro-regular-svg-icons/faRefresh';
import { faWarning } from '@fortawesome/pro-regular-svg-icons/faWarning';
import { faArrowsRepeat } from '@fortawesome/pro-regular-svg-icons/faArrowsRepeat';

import {
  IconAnimation,
  IconRotation,
  SemanticCategory,
  IconLabel,
} from '../types';

export const SEMANTIC_CATEGORY: SemanticCategory = 'status';
export type SemanticCategoryName = typeof SEMANTIC_CATEGORY;

export const icons = {
  running: faCirclePlay,
  completed: faCircleCheck,
  'debug-waiting': faFlask,
  failed: faCircleXmark,
  'paused-by-failure': faWarning,
  pending: faHourglassHalf,
  'pending-throttled': faGaugeHigh,
  'pending-retry': faRefresh,
  'paused-before-execution': faCirclePause,
  'skipped-execution': faForwardStep,
  'paused-after-execution': faCirclePause,
  cancelled: faBan,
  'waiting-for-branches': faMerge,
  blocked: faArrowsRepeat,
};

export const labels: IconLabel = {
  running: {
    title: (t) => '',
    description: (t) => t('Running'),
  },
  completed: {
    title: (t) => '',
    description: (t) => t('Completed'),
  },
  'debug-waiting': {
    title: (t) => '',
    description: (t) => t('Debug Waiting'),
  },
  failed: {
    title: (t) => '',
    description: (t) => t('Failed'),
  },
  'paused-by-failure': {
    title: (t) => '',
    description: (t) => t('Paused by Failure'),
  },
  pending: {
    title: (t) => '',
    description: (t) => t('Pending'),
  },
  'pending-throttled': {
    title: (t) => '',
    description: (t) => t('Pending (Throttled)'),
  },
  'pending-retry': {
    title: (t) => '',
    description: (t) => t('Pending (Retry)'),
  },
  'paused-before-execution': {
    title: (t) => '',
    description: (t) => t('Paused'),
  },
  'skipped-execution': {
    title: (t) => '',
    description: (t) => t('Skipped Execution'),
  },
  'paused-after-execution': {
    title: (t) => '',
    description: (t) => t('Paused After Execution'),
  },
  cancelled: {
    title: (t) => '',
    description: (t) => t('Cancelled'),
  },
  'waiting-for-branches': {
    title: (t) => '',
    description: (t) => t('Waiting for Branches'),
  },
  blocked: {
    title: (t) => '',
    description: (t) => t('Waiting for Loop'),
  },
};

export type ValidIcons = keyof typeof icons;

export const rotation: IconRotation = {};

export const animation: IconAnimation = {};
